import axios from 'axios'
import { URLS } from '../factories'
import { AuthModule } from '../store'

const FeatureSwitchService = {
  isFeatureEnabled (feature: string) {
    return new Promise(function (resolve, reject) {
      const featureSwitchApiUrl = AuthModule.isProduction ? URLS.production.featureSwitchingApiUrl : URLS.replica.featureSwitchingApiUrl

      axios({
        method: 'GET',
        url: featureSwitchApiUrl + '/api/features/' + feature
      }).then((response) => {
        const isEnabled = !!(response && response.data)
        resolve(isEnabled)
      }).catch(() => {
        reject(new Error())
      })
    })
  }
}

export default FeatureSwitchService
